import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IWorkType, IWorkTypeResponse } from "./IWorkTypes";

export const workTypesApi = createApi({
  reducerPath: "workTypes",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.WORKTYPES,
  }),
  tagTypes: ["workTypes", "workType"],
  endpoints: (builder) => ({
    getFilteredWorks: builder.query<IWorkTypeResponse, string>({
      query(searchParams) {
        return {
          url: `/pagination?${searchParams}`,
        };
      },
      providesTags: ["workTypes"],
    }),
    getAllWorks: builder.query<IWorkType[], void>({
      query() {
        return {
          url: "",
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["workTypes"],
    }),
    addWork: builder.mutation<any, Omit<IWorkType, "id">>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["workTypes"],
    }),
    getWork: builder.query<IWorkType, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["workType"],
    }),
    editWork: builder.mutation<IWorkType, IWorkType>({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["workType", "workTypes"],
    }),
    deleteWork: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["workTypes"],
    }),
  }),
});

export const {
  useAddWorkMutation,
  useDeleteWorkMutation,
  useEditWorkMutation,
  useGetAllWorksQuery,
  useGetWorkQuery,
  useGetFilteredWorksQuery,
} = workTypesApi;
